import { Type } from '@angular/core';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HttpModule, JsonpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { MdIconModule, MdButtonModule, PortalModule } from '@angular/material';

import { TdFileSelectDirective } from './directives/file-select.directive';
import { TdFileDropDirective } from './directives/file-drop.directive';
import { TdFileUploadComponent } from './file-upload/file-upload.component';
import { TdFileInputComponent, TdFileInputLabelDirective } from './file-input/file-input.component';
import { TdFileService } from './services/file.service';

const /** @type {?} */ TD_FILE: Type<any>[] = [
  TdFileSelectDirective,
  TdFileDropDirective,
  TdFileUploadComponent,
  TdFileInputComponent,
  TdFileInputLabelDirective,
];

export { TdFileUploadComponent } from './file-upload/file-upload.component';
export { TdFileInputComponent, TdFileInputLabelDirective } from './file-input/file-input.component';
export { TdFileSelectDirective } from './directives/file-select.directive';
export { TdFileDropDirective } from './directives/file-drop.directive';
export { TdFileService, IUploadOptions } from './services/file.service';
export class QuiverFileModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    HttpModule,
    JsonpModule,
    FormsModule,
    CommonModule,
    MdIconModule,
    MdButtonModule,
    PortalModule,
  ],
  declarations: [
    TD_FILE,
  ],
  exports: [
    TD_FILE,
  ],
  providers: [
    TdFileService,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverFileModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverFileModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverFileModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
